export default {
  home: {
    title: 'Inicio',
    aiBannerTxt: {
      title: 'Tornar a Educação em IA Realidade',
      subtitle: 'Capacitação Digital da IA+ Educação, Integrando Conceitos Inovadores',
      description: 'Foco em produtos e serviços técnicos personalizados a laser, ajudando instituições e empresas a integrar "AI+ Education"'
    },
    description: 'Bienvenido a nuestro sitio web de marketing en Vue.js',
    banner: {
      slide1: {
        title:
          'Kits STEAM | Kits de Inteligencia Artificial | Kits de Corte Láser',
        description:
          'Ofrecemos soluciones educativas innovadoras STEAM y diversos kits para familias, educadores y distribuidores, diseñados para niños de 3 a 16 años.',
      },
      slide2: {
        title:
          'Kits profesionales diseñados para fomentar la creatividad de los niños',
        description:
          'Cursos, equipos y software integrados para facilitar el aprendizaje basado en proyectos',
      },
      slide3: {
        title: 'Educación tecnológica orientada al futuro',
        description:
          'Aprendizaje práctico, integración interdisciplinaria, desarrollo de habilidades de resolución de problemas y colaboración',
      },
    },
    factory: {
      banner: {
        alt: 'Banner de fábrica inteligente',
        title: 'Soluciones de Fábrica Inteligente',
        description:
          'Montaje de líneas de producción | Sensores industriales | Control PLC y adquisición de datos',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'Recursos educativos',
      resources: [
        {
          title: 'Material de enseñanza basado en proyectos',
          desc: 'PPT de cursos y guías, diseño de actividades en clase y sugerencias de evaluación.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'Ejemplos y materiales de escenario',
          desc: 'Ejemplos y fragmentos de código para control de cintas transportadoras, detección de estaciones y coordinación de equipos.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'Tareas de extensión post-clase',
          desc: 'Tareas extendidas y sugerencias de aplicación interdisciplinaria para fomentar la investigación y la creatividad.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'Introducción al producto',
        desc: 'La solución de fábrica inteligente se centra en el montaje de líneas de producción y el control por programación, abarcando sensores industriales, reconocimiento de estaciones, control PLC/microcontrolador y adquisición de datos, destacando la práctica y la formación integral.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'Cursos complementarios',
        desc: 'Cursos basados en proyectos sobre montaje de líneas de producción, sensores industriales, control PLC y adquisición de datos, enfatizando la práctica y el entrenamiento integral.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'Módulo de cinta transportadora',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'Sensor fotoeléctrico',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'Unidad de control PLC',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'Módulo de brazo robótico',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'Módulo de reconocimiento de códigos de barras',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'Sensor de temperatura y humedad',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'Módulo de accionamiento de motor',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'Módulo de detección de estación',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'Módulo de parada de emergencia',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'Gateway de adquisición de datos',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'Soluciones educativas STEAM de Zetok',
      learnMore: 'Más información >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'Kits Zetok',
          description:
            'A través de la práctica y el aprendizaje basado en proyectos, se desarrolla el pensamiento creativo y las habilidades prácticas.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'Good Laser Cortadora y Grabadora Láser',
          description:
            'La cortadora láser aporta una nueva experiencia de aprendizaje práctico en educación STEAM.',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'Escenarios educativos',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'Soluciones educativas STEM',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'Soluciones de espacios makers',
        },
      ],
    },
    aiBanner: {
      alt: 'Banner AI',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'Kits Zetok',
      title: 'Kits de Inteligencia Artificial',
      description:
        'Los kits de inteligencia artificial suelen incluir proyectos interactivos y prácticos, capaces de despertar el interés y la curiosidad de los estudiantes por la tecnología.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'Carrusel de kits',
      title: 'Fomenta el pensamiento creativo',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'Kits Zetok y Cortadoras Láser Good Laser',
      tabs: {
        kits: 'Kits',
        courses: 'Cursos',
        laser: 'Equipos láser',
        software: 'Software',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'Kit de introducción al corte láser',
            description: '(incluye madera)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'Caja de Ciencias Maravillosa',
            description: '(incluye madera + kit de microcircuitos)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'Kit de programación de IA',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'Exploración Científica - Infantil',
            description: '（6 cursos）',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'STEAM Maker - Adolescentes',
            description: '（3 cursos）',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'Curso de Corte Láser',
            description: '（3 cursos）',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'Programa de IA',
            description: '（4 cursos）',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530',
            description: 'Cortadora y grabadora láser CO2 de escritorio 55W',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description:
              'Cortadora y grabadora láser profesional de escritorio',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530',
            description:
              'Cortadora y grabadora láser azul inteligente de escritorio',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'Marcadora láser de alta precisión',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'Plataforma de aprendizaje Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'Plataforma en la nube Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
          {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
    switch_lang: 'English',
    nav: {
      products: 'Productos',
      smartFarm: 'Granja Inteligente',
      smartHome: 'Hogar Inteligente',
      smartTraffic: 'Tráfico Inteligente',
      smartFactory: 'Fábrica Inteligente',
      laserSteam: 'Kits STEAM y Corte Láser',
      dreamScience: 'Kits Ciencia de Sueños',
      course: 'Cursos',
      device: 'Equipos',
      education: 'Soluciones Educativas',
      stem: 'Soluciones Educativas STEM',
      maker: 'Soluciones de Espacios Makers',
      software: 'Software',
      service: 'Servicios y Soporte',
      afterSale: 'Download de Tutoriais',
      about: 'Acerca de nosotros',
      aboutUs: 'Acerca de nosotros',
      dealer: 'Conviértete en distribuidor',
      cooperation: 'Cooperación educativa y uso de productos',
      news: 'Noticias',
      coursesSeries: 'Cuatro series de cursos',
      viewMore: 'Ver más',
      store: 'Loja'
    },
    globalContactForm: {
      title: 'Contáctanos',
      subtitle:
        'Si tienes alguna pregunta o necesidad, no dudes en contactarnos. Estamos aquí para ayudarte.',
      fields: {
        name: 'Nombre',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        company: 'Empresa',
        message: 'Mensaje',
      },
      placeholders: {
        name: 'Introduce tu nombre',
        email: 'Introduce tu correo electrónico',
        phone: 'Introduce tu número de teléfono',
        company: 'Introduce el nombre de tu empresa',
        message: 'Escribe tu consulta o necesidad',
      },
      validation: {
        name: 'Introduce tu nombre',
        email: 'Introduce tu correo electrónico',
        emailFormat: 'Formato de correo electrónico inválido',
        phone: 'Introduce tu número de teléfono',
        message: 'Escribe un mensaje',
      },
      submit: 'Enviar',
      submitting: 'Enviando…',
      visual: {
        title: 'Servicios Profesionales',
        description:
          'Enfocados en la educación tecnológica para niños de 3 a 16 años, con espacios makers y desarrollo de productos y cursos relacionados.',
      },
      contact: {
        phone: 'Teléfono de contacto',
        email: 'Correo electrónico',
      },
    },
    thankYou: {
      metaTitle: 'Gracias',
      title: '¡Gracias por tu envío!',
      description:
        'Hemos recibido tu información y nos pondremos en contacto lo antes posible.',
      seoDescription:
        'Envío recibido. Nuestro equipo se pondrá en contacto en breve.',
      backHome: 'Volver al inicio',
      browseProducts: 'Explorar productos',
      contactSupport: 'Contactar soporte',
      nextStepsTitle: 'Qué ocurre a continuación',
      nextSteps: [
        'Nuestro equipo revisará tu solicitud en 1–2 días hábiles.',
        'Si es necesario, nos pondremos en contacto para obtener más detalles.',
        'Puedes seguir explorando o contactarnos por teléfono o correo.',
      ],
      contactTitle: '¿Necesitas ayuda inmediata?',
      contactPhoneLabel: 'Teléfono de atención:',
      contactEmailLabel: 'Correo electrónico:',
    },
  },

  about: {
    banner: {
      alt: 'Banner sobre nosotros',
      title:
        'Zetok se enfoca en la educación innovadora, ofreciendo kits y cursos de alta calidad',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'Nuestra misión',
      desc: 'Nuestra misión es empoderar la educación mediante tecnologías avanzadas de inteligencia artificial, estimular la innovación y formar futuros líderes y creadores. Creemos que al proporcionar herramientas y soluciones educativas de alta calidad, podemos ayudar a estudiantes y educadores a alcanzar su máximo potencial.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'Nuestra visión',
      desc: 'Potenciar la educación con tecnología, brindando a cada estudiante acceso a recursos STEM de alta calidad, fomentando su potencial y formando futuros innovadores y líderes.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'Nuestros productos',
      tabs: ['Kits', 'Cursos', 'Equipos láser'],
      items: [
        {
          title: 'Kits',
          desc: 'Ofrecemos una variedad de kits STEM, incluyendo inteligencia artificial, robótica, programación y experimentos científicos, diseñados para ser fáciles de usar y adecuados para diferentes edades.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'Cursos',
          desc: 'Nuestros cursos, diseñados por expertos en educación, se integran con los kits para ofrecer una experiencia de aprendizaje completa, desde conceptos básicos hasta aplicaciones avanzadas.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'Equipos láser',
          desc: 'Nuestros equipos de corte y grabado láser son seguros y fáciles de usar, diseñados especialmente para entornos educativos, brindando a los estudiantes la oportunidad de convertir sus ideas en productos reales.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'Únete a nosotros como distribuidor de Zetok',
        title: 'Únete a nosotros como distribuidor de Zetok',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title:
          'Explora nuevas oportunidades educativas y comparte los logros de la innovación',
        desc: 'Zetok te invita a expandir el camino de la educación STEM, ofreciendo kits de IA, equipos láser y más, fomentando la creatividad de los estudiantes. ¡Únete y ganemos juntos!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'Nuestra misión',
        items: [
          {
            title: 'Productos líderes',
            desc: 'Accede a las mejores herramientas educativas STEAM del mercado.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'Altos beneficios',
            desc: 'Disfruta de descuentos competitivos y incentivos de venta.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'Apoyo de mercado',
            desc: 'Proporcionamos materiales de marketing y capacitación en ventas para ayudarte a abrir mercado rápidamente.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'Colaboración de marca',
            desc: 'Trabaja junto a Zetok y comparte la influencia y los recursos de la marca.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'Banner de cooperación',
        title: 'Cooperación de productos',
        cta: 'Contacta ahora',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'Despierta el potencial de futuros científicos e ingenieros',
        desc: 'Únete a nuestro programa de promoción educativa STEM, obteniendo ofertas especiales y pruebas de productos diseñadas para educadores. Proporcionamos herramientas STEM innovadoras y descuentos exclusivos para impulsar la formación de la próxima generación de innovadores.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: 'Actúa ahora y abre un nuevo capítulo en educación STEM',
        items: [
          {
            title: 'Prueba gratuita de productos',
            desc: 'Prueba nuestras herramientas antes de la compra.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'Descuentos exclusivos',
            desc: 'Ofrecemos soluciones STEM económicas para tu aula o escuela.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'Recursos educativos',
            desc: 'Accede a recursos didácticos y planes de curso completos para apoyar tu enseñanza.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'Contáctanos',
        desc: 'Si tienes preguntas o necesidades, no dudes en contactarnos. Estamos aquí para ayudarte.',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'Banner del centro de noticias',
        title: 'Centro de noticias',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'Centro de noticias',
      tabs: [
        { key: 'company', label: 'Noticias de la empresa' },
        { key: 'industry', label: 'Noticias del sector' },
        { key: 'expo', label: 'Noticias de exposiciones' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'Zetok lanza nuevo kit de IA para aula',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title:
              'Colaboración con escuelas locales para proyecto piloto STEM',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title: 'Actualización de software mejora la gestión del aula',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: 'Talleres de formación para docentes',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'Red de distribuidores se expande a más regiones',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: 'Nueva serie de cursos enfocada en proyectos reales',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: 'Revisión anual resalta logros en innovación',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: 'Plan comunitario STEM para jóvenes',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title:
              'Tendencias globales: Aprendizaje basado en proyectos en STEM',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'IA en educación: Mejores prácticas emergentes',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title:
              'Nuevos estándares de cursos enfatizan habilidades prácticas',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title: 'Hardware educativo más cercano a las necesidades del aula',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: 'Proyectos STEAM continúan en varios distritos',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: 'Proyectos de desarrollo sostenible llegan a STEM',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title:
              'Espacios makers influyen en nuevas formas de aprendizaje innovador',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'Zetok en exposición de tecnología educativa',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title:
              'Resultados de proyectos estudiantiles en exposiciones regionales',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title:
              'Demostraciones interactivas en eventos makers atraen atención',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: 'Taller de programación visual para docentes',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: 'Nuevos equipos presentados a socios educativos',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },

  finance: {
    contact: {
      success:
        'Envio bem-sucedido, entraremos em contato o mais breve possível',
      error: 'Falha no envio, por favor tente novamente mais tarde',
      networkError: 'Erro de rede, verifique sua conexão e tente novamente',
    },
  },
  footer: {
    subscribePlaceholder: 'Seu número de telefone e endereço de e-mail',
    subscribe: 'Assinar',
    subscribeSuccess: 'Assinatura bem-sucedida',
    contact: {
      sales: 'Linha de vendas: +86 18379276683',
      service: 'Linha de serviço: +86 400 968 0598',
      email: 'Email: sam@zz-steam.com',
      address:
        'Endereço: Edifício Huashengda, Bloco A, Rua Bagua 4, Distrito de Futian, Shenzhen',
    },
    icp: 'Política de Privacidade · Termos de Usuário © Zhongze Education (Shenzhen) Co., Ltd. ICP nº 2024289240-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'Banner da solução educacional STEM',
        title: 'Liderança Criativa em Educação STEM',
        description:
          'Focando em K12, nos dedicamos à educação STEM criativa, despertando a curiosidade, desenvolvendo lógica e incentivando a paixão pela programação.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'Educação em Inteligência Artificial e Programação',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'Fácil de aprender e usar',
            description:
              'Programação gráfica, iniciantes aprendem rapidamente, criando projetos de IA personalizados facilmente.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'Poderoso',
            description:
              'Hardware inteligente, interação por voz, criatividade sem limites.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'Alta escalabilidade',
            description:
              'Conecte componentes de hardware, inspire imaginação, crie infinitamente.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'Cursos abrangentes',
            description:
              'Cursos completos, do básico à prática, ajudando os alunos a construir seu conhecimento.',
          },
        ],
      },
      scenes: {
        title: 'Conheça nossos cursos especiais',
        items: [
          {
            tab: 'Educação Escolar',
            title: 'Educação Escolar em IA',
            desc: 'Use kits de IA para criar assistentes de voz inteligentes, despertando interesse, desenvolvendo lógica e habilidades de programação, e experimentando o poder da inteligência artificial.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'Treinamento para Competições',
            title: 'Treinamento para Competições',
            desc: 'Kits inteligentes apoiam competições de robótica e inovação tecnológica, permitindo que os alunos projetem trabalhos inteligentes e melhorem colaboração e criatividade.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'Aprendizagem em Casa',
            title: 'Aprendizagem em Casa',
            desc: 'Pais e filhos aprendem juntos projetos de IA, desenvolvendo habilidades práticas, fortalecendo relacionamentos e promovendo alfabetização tecnológica.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title:
          'IA + Educação: Iniciando uma Nova Era de Aprendizado Inteligente',
        desc: 'Com tecnologia de IA, caminhos de aprendizagem personalizados e ensino preciso, cada aluno pode navegar pelo oceano do conhecimento sem obstáculos.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'Séries de Kits STEM',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'Banner da Solução de Espaço Maker',
        title: 'Explore Nosso Espaço Maker',
        description:
          'No espaço maker, educação e tecnologia inovadora se unem, oferecendo aos alunos uma plataforma de prática e exploração.',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'Habilidades Maker Completas',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'Aplicação de Ferramentas Tecnológicas',
            desc: 'Programação gráfica, fácil de usar, iniciantes podem montar projetos de IA rapidamente.',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'Abertura e Flexibilidade',
            desc: 'Espaço maker, exploração livre, parque exclusivo para liberar criatividade.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'Prática Manual',
            desc: 'Pratique, construa, experimente e explore, iniciando a jornada de aprendizado.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'Aprendizado Colaborativo',
            desc: 'Incentiva os alunos a colaborar em equipes, desenvolvendo habilidades de comunicação e cooperação.',
          },
        ],
      },
      scenes: {
        title: 'Cenários de Aplicação do Espaço Maker',
        items: [
          {
            tab: 'Cursos de Artes na Escola',
            title: 'Cursos de Artes na Escola',
            desc: 'Complemento poderoso para cursos de artesanato, design e artes visuais.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'Clubes de Pesquisa e Inovação',
            title: 'Clubes de Pesquisa e Inovação',
            desc: 'Oferece plataforma prática para clubes de inovação da escola.',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'Laboratórios Educacionais',
            title: 'Laboratórios Educacionais',
            desc: 'Adequado para escolas, universidades ou laboratórios, atualiza ambientes de aprendizagem e fornece cortadoras a laser profissionais para alunos.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'Ferramentas para Transformar Criatividade em Realidade',
        desc: 'Com a precisão de corte a laser e a interação inteligente de robôs programáveis, os alunos podem transformar ideias abstratas em projetos concretos.',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'Séries de Kits Maker',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'Banner da Página de Software',
      title: 'Centro de Software Zetok',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'Download de Software',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'Light maker App',
          buttonText: 'Baixar para Mobile',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good-laser Light maker',
          buttonText: 'Baixar para Desktop',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: 'Plataforma de Aprendizagem Zhongze App',
          buttonText: 'Baixar para Mobile',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'Plataforma de Aprendizagem Zhongze Desktop',
          buttonText: 'Baixar para Desktop',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'Software Light Maker para Equipamentos a Laser',
          desc: 'Integra design gráfico e controle de equipamentos, economizando tempo e fornecendo solução completa de design e controle a laser.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'Sistema de Design Poderoso e Fácil de Usar',
            desc: 'Software criativo poderoso compatível com JPG, DXF, AI, DST, PNG, BMP, TIF, SVG.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'Profissional',
            desc: 'Funções de desenho profissional, atendendo a todas as necessidades de produção, de designs complexos a cortes simples.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'Fácil de Operar',
            desc: 'Interface amigável, compatível com diversos equipamentos a laser, alta eficiência em corte e gravação.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'Software Light Maker para Equipamentos a Laser',
          desc: 'Integra design gráfico e controle de equipamentos, economizando tempo e fornecendo solução completa de design e controle a laser.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'Sistema de Design Poderoso e Fácil de Usar',
            desc: 'Software criativo poderoso compatível com JPG, DXF, AI, DST, PNG, BMP, TIF, SVG.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'Profissional',
            desc: 'Funções de desenho profissional, atendendo a todas as necessidades de produção, de designs complexos a cortes simples.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'Fácil de Operar',
            desc: 'Interface amigável, compatível com diversos equipamentos a laser, alta eficiência em corte e gravação.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'Plataforma em Nuvem Zetok',
          desc: 'Ferramenta inovadora de gestão educacional, oferecendo solução completa para professores, alunos e escolas. Permite envio de tarefas, monitoramento de equipamentos, reparos e configuração de parâmetros.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: 'Operação Conveniente',
            desc: 'Criação com um clique: biblioteca e configuração de parâmetros integradas. Monitoramento: acompanhe o status do equipamento em tempo real.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: 'Gestão Unificada',
            desc: 'Suporte à conexão de outros equipamentos maker, gerenciamento com um clique, aumentando eficiência.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'Monitoramento em Tempo Real',
            desc: 'Acompanhe o status do equipamento, reporte falhas rapidamente, manutenção programada para prolongar vida útil e melhorar qualidade de corte.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'Plataforma de Aprendizagem Zetok',
          desc: 'A Plataforma de Aprendizagem Zetok é uma ferramenta de ensino online inovadora, projetada para oferecer uma solução de software educacional abrangente para alunos e professores. Acesse e use nossa plataforma com facilidade, seja em dispositivos móveis ou computadores.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-1/514/403',
            title: 'Inteligente e Fácil para Iniciantes',
            desc: 'Biblioteca completa e parâmetros predefinidos, suporte a criação com um clique, guia detalhado para iniciantes, monitoramento em nuvem para segurança e eficiência.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-2/514/403',
            title: 'Criação com IA',
            desc: 'Criação com um clique e geração de imagens AI simplificam o design, aumentando eficiência. Basta inserir instruções ou imagens de referência.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-3/514/403',
            title: 'Nova Experiência de Aprendizado Eficiente',
            desc: 'Integra cursos, design gráfico e corte a laser em uma plataforma, operação simples, cartões organizam módulos para aprendizado fluido.',
          },
        ],
      },
    },
  },
  product: {
    farm: {
      banner: {
        alt: 'Banner Fazenda Inteligente',
        title: 'Kit de Aprendizagem Fazenda Inteligente',
         btnText: 'Comprar agora',
        description:
          'Ensino baseado em projetos | Programação + Hardware + IA | Para Ensino Fundamental e Médio',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'Conteúdo do Curso',
        resourceTitle: 'Recursos Educacionais',
        equipmentsTitle: 'Equipamentos',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'Conteúdo Diversificado',
          desc: '12 aulas do básico ao avançado: desde monitoramento de temperatura até irrigação inteligente e controle de temperatura, progresso completo em um só kit.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'Integração Interdisciplinar',
          desc: 'Cada projeto envolve programação, hardware eletrônico, estruturas mecânicas e outras disciplinas, ajudando os alunos a aplicar conhecimentos de forma prática e desenvolver pensamento interdisciplinar.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'Temas Próximos à Vida Real',
          desc: 'Com o tema Fazenda Inteligente, próximo da vida dos alunos, despertando interesse e engajamento no aprendizado.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'PPTs e Apostilas Completos',
          desc: '16 aulas com PPTs e apostilas, alinhadas aos projetos, oferecendo material rico aos professores e reduzindo o tempo de preparação.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'Vídeos de Montagem dos Projetos',
          desc: 'Os vídeos mostram claramente o processo de montagem, ajudando os alunos a compreender e dominar os passos, aumentando a eficiência do aprendizado.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'Materiais de Apoio',
          desc: 'Apostilas e outros materiais auxiliam os alunos com instruções detalhadas, facilitando revisão e estudo independente.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'Fita de LED RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo Relógio DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de Temperatura e Umidade DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de Movimento',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo Ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor Óptico em Canal',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de Botão',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa Controladora',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Versão Expandida',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    home: {
      banner: {
        alt: 'Kit de Aprendizagem Casa Inteligente',
        title: 'Kit de Aprendizagem Casa Inteligente',
        btnText: 'Comprar agora',
        description:
          'Programação e Introdução à IA | Ensino baseado em projetos | Primeira escolha em aulas de tecnologia para ensino fundamental e médio',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'Vantagens do Kit de Iniciação à Casa Inteligente',
      resources: [
        {
          title: 'Recursos Completos',
          desc: 'Fornece materiais didáticos completos para facilitar o ensino do professor e o aprendizado do aluno.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'Integração Interdisciplinar',
          desc: 'Cada projeto envolve programação, hardware eletrônico, estruturas mecânicas e outras disciplinas, promovendo aplicação prática e pensamento interdisciplinar.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'Tarefas de Extensão Pós-Aula',
          desc: 'Tarefas adicionais e sugestões de aplicação interdisciplinar estimulam investigação e criação.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'Cursos Associados',
        desc: 'Inclui 12 projetos selecionados, cobrindo aspectos da casa inteligente, como campainha eletrônica, luz externa regulável, garagem com sensor, controle de acesso por senha, alerta de gás, alarme anti-roubo, luzes coloridas, luz ambiente musical, detecção de luz solar, monitoramento de temperatura ambiente e ventilador controlado.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'Diversos Cenários de Aplicação',
      scenes: [
        {
          title: 'Aulas em Sala',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'Desenvolvimento Criativo Independente',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'Interação Pais e Filhos em Casa',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'Exposição de Projetos',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'Equipamentos',
      equipments: [
        {
          title: 'Fita de LED RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo Relógio DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de Temperatura e Umidade DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de Movimento',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo Ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor Óptico em Canal',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de Botão',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa Controladora',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Versão Expandida',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    factory: {
      banner: {
        alt: 'Banner Fábrica Inteligente',
        title: 'Kit de Aprendizagem Fábrica Inteligente',
        btnText: 'Comprar agora',
        description: `· Cobertura completa de sensores/controle/acionamento <br> · Simulação de linha de produção real <br> · Desenvolvendo "Engenheiros do Futuro"`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'Características do Produto',
      resources: [
        {
          title: 'Experiência Central da Indústria 4.0',
          desc: 'Alunos praticam sensores, controle, acionamento e gestão de dados em linha de produção simulada.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'Aprendizado Baseado em Projetos',
          desc: 'Inclui tutoriais de programação e 12 aulas com PPTs para fácil aprendizado.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'Simulação de Cenários Reais',
          desc: 'Braços robóticos inteligentes, sistema de classificação automático e armazém inteligente simulam gestão logística, iniciando a prática STEM.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'Introdução do Produto',
        desc: 'O kit de aprendizagem Fábrica Inteligente combina programação, hardware eletrônico, estruturas mecânicas, corte a laser e introdução à IA. Destinado a alunos do ensino fundamental e médio, com o tema "Manufatura Inteligente·Criando o Futuro", simula ambientes de produção e desenvolve habilidades de investigação científica, design de engenharia, programação e inovação colaborativa.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'Cursos Associados',
        desc: '12 cursos selecionados: introdução à fábrica inteligente, processos de produção, aplicação de sensores, fundamentos de acionamento mecânico, construção de sistemas de transporte, classificação automática, controle de colaboração de estações, montagem de braços robóticos, classificação inteligente e coleta de dados. Cursos enfatizam prática e treinamento sistêmico.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'Equipamentos',
      equipments: [
        {
          title: 'Fita de LED RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo Relógio DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de Temperatura e Umidade DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de Movimento',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo Ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor Óptico em Canal',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de Botão',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa Controladora',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Versão Expandida',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    kits: {
      laserSteam: {
        banner: {
          alt: 'Banner Kit STEAM Corte a Laser',
          title: 'Kit STEAM Corte a Laser',
          btnText: 'Comprar agora',
          description:
            'Solução educacional de fabricação inteligente para desenvolver criatividade e trabalho em equipe em um só kit',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        resourcesTitle: 'Vantagens do Kit STEAM Corte a Laser',
        resources: [
          {
            title: 'Teoria de Inteligências Múltiplas',
            desc: 'Baseado na teoria de múltiplas inteligências, desenvolve criatividade, pensamento crítico, resolução de problemas e colaboração.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'Aprendizado Baseado em Projetos',
            desc: 'Permite aprendizado prático, aumentando interesse e eficiência.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'Educação STEAM',
            desc: 'Conteúdos integrando ciência, tecnologia, engenharia, artes e matemática, promovendo pensamento interdisciplinar.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'Ensino Detalhado',
          tabs: [
            { key: 'cutter', label: 'Cortadora a Laser' },
            { key: 'lesson', label: 'Cursos Associados' },
            { key: 'material', label: 'Materiais Didáticos' },
            { key: 'software', label: 'Software' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        aiBanner: {
          title: 'Educação em IA, início inteligente',
          desc: 'Integra a educação STEAM com elementos de IA para uma experiência de aprendizagem abrangente.',
        },
        equipmentsTitle: 'Equipamentos',
      },
      dreamScience: {
        banner: {
          alt: 'Banner Kit Ciência dos Sonhos',
          title: 'Caixa Mágica de Ciência (Kit Ciência dos Sonhos)',
          description:
            'Conceito científico básico | Pensamento científico | Prática investigativa | Responsabilidade e atitude',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'Conteúdo do Kit',
        resources: [
          {
            title: 'Materiais para Experimentos Científicos',
            desc: 'Para realizar diversos experimentos e projetos científicos.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'Recursos Educacionais',
            desc: 'Inclui PPTs e apostilas, cobrindo um semestre de atividades de ensino, alinhados aos projetos e pontos de aprendizagem.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'Vídeos e Apostilas de Montagem',
            desc: 'Materiais auxiliares que ajudam os alunos a entender e dominar os passos de operação.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'Objetivos Educacionais',
        objectives: [
          {
            title: 'Capacidade de Investigação Científica',
            desc: 'Formular perguntas, planejar, coletar e analisar dados',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'Habilidade em Prática de Engenharia',
            desc: 'Montar e testar, iterar e melhorar soluções',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'Integração Interdisciplinar',
            desc: 'Combinar matemática, física e artes para completar projetos',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'Público-alvo',
          description:
            'Alunos do ensino fundamental e médio: adequado para diferentes idades, aprimorando ciência e prática. Professores: fornece recursos e guias didáticos para apoiar o ensino.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'Imagem de Introdução',
        },
      },
    },

    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: 'Banner Ver Todos os Kits',
        title: 'Séries de Kits',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'Centrado em projetos, os alunos desenvolvem a capacidade de aplicar conhecimentos para resolver problemas através da realização de diversas tarefas de projeto.',
      moreText: 'Saiba mais',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'Kit de Aprendizagem Fazenda Inteligente',
          desc: 'Centrado em projetos, estimula a criatividade e habilidades práticas dos alunos, desenvolvendo técnicas para resolver problemas reais.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'Kit de Aprendizagem Casa Inteligente',
          desc: 'Combina programação, hardware eletrônico, estruturas mecânicas, corte a laser e introdução à inteligência artificial, oferecendo uma experiência de aprendizado completa.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'Kit de Aprendizagem Transporte Inteligente',
          desc: 'Um kit educacional baseado em projetos que integra programação, hardware eletrônico, estruturas mecânicas, corte a laser e introdução à inteligência artificial.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'Kit de Aprendizagem Fábrica Inteligente',
          desc: 'Abrange conhecimentos básicos e casos práticos de inteligência artificial, guiando os alunos gradualmente e ajudando-os a construir um sistema de conhecimento estruturado.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Kit STEAM Corte a Laser',
        //   desc: 'O kit STEAM de corte a laser é guiado por teorias de inteligências múltiplas, conceitos de educação STEAM e aprendizado baseado em projetos.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'Kit Ciência dos Sonhos',
        //   desc: 'O Kit Ciência dos Sonhos atende às necessidades de diferentes estágios de aprendizado, despertando o interesse científico e o espírito exploratório dos alunos.',
        //   link: '/products/farm',
        // },
      ],
    },

    traffic: {
      banner: {
        alt: 'Banner Transporte Inteligente',
        title: 'Kit de Aprendizagem Transporte Inteligente',
        btnText: 'Comprar agora',
        description: `12 cursos baseados em projetos
  <br>· Programação Gráfica / Python
  <br>· Simulação de Cenários Reais
  <br>· Pronto para Ensino`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'Características do produto',
      resources: [
        {
          title: 'Investigação Científica e Inovação',
          desc: 'Os alunos constroem sistemas de transporte inteligente usando módulos eletrônicos e estruturas mecânicas.',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'Forte Valor Educacional',
          desc: 'Pode construir projetos como semáforos inteligentes, faixas de pedestres e estacionamentos, ajudando os alunos a compreender conceitos de transporte inteligente.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'Recursos Completos',
          desc: 'Inclui PPTs e apostilas para 12 aulas, vídeos de montagem de projetos e materiais auxiliares para cursos baseados em projetos.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'Introdução do Produto',
        desc: 'O kit de transporte inteligente para escolas primárias e secundárias tem como tema "Mobilidade Inteligente" e "Segurança no Trânsito", combinando controle eletrônico, sensores e outras tecnologias para guiar os alunos a projetar e construir sistemas de transporte inteligentes, simulando cenários reais de trânsito e promovendo habilidades científicas e criatividade.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'Cursos Associados',
        desc: 'Inclui cursos baseados em projetos sobre percepção e controle de tráfego, sinalização integrada, planejamento de rotas, adaptáveis a diferentes estágios e horários de aula.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'Equipamentos',
      equipments: [
        {
          title: 'Fita de LED RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'Módulo Relógio DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'Sensor de Temperatura e Umidade DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'Sensor de Movimento',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'Módulo LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'Módulo Ventilador',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'Interruptor Óptico em Canal',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'Módulo de Botão',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'Placa Controladora',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'Versão Expandida',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    banner: {
      alt: 'Banner da Página de Produtos',
      title: 'Produtos e Soluções Zetok',
      description:
        'Kits, cursos, equipamentos e softwares integrados, apoiando aprendizado baseado em projetos',
      image: 'https://picsum.photos/id/1069/1600/900',
    },

    courses: {
      banner: {
        alt: 'Banner de Cursos',
        title: 'Quatro Sistemas de Cursos',
        description:
          'Conteúdos abrangem ciência, tecnologia, engenharia, arte e matemática (STEAM), promovendo integração e aplicação de conhecimentos interdisciplinares pelos alunos.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'Conheça Nossos Cursos Especiais',
        nav: [
          'Idade 3-6 anos',
          'Idade 6-12 anos',
          'Idade 8-13 anos',
          'Idade 9-15 anos',
        ],
        entries: [
          {
            title: 'Sistema de Exploração Científica · Infantil (6 cursos)',
            desc: 'Explora fenômenos comuns do dia a dia usando materiais científicos para entender regras e princípios do desenvolvimento das coisas.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'Sistema STEAM Maker Jovens (3 cursos)',
            desc: 'Estimula a criatividade e permite usar equipamentos para transformar ideias em produtos práticos.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'Sistema de Cursos de Corte a Laser (3 cursos)',
            desc: 'Permite cortar diferentes peças estruturais, montar estruturas 3D e aprimorar sua estética. Desenvolve lógica e princípios de programação.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'Sistema de Cursos de Inteligência Artificial (4 cursos)',
            desc: 'Usa ferramentas e equipamentos para criar produtos inteligentes e funcionais, solucionando problemas do cotidiano.',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'Vantagens do Curso',
        details: [
          {
            title: 'Prática Intensa',
            description: 'Aprender fazendo, teoria em ação',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'Desenvolvimento do Pensamento Criativo',
            description: 'Projetar e criar soluções inovadoras',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'Aprendizagem Baseada em Projetos',
            description:
              'Aprender com projetos, consolidando conhecimento na prática',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'Exploração Tecnológica Avançada',
            description:
              'Acompanhar tendências tecnológicas e aplicar kits inteligentes',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'Ensino Sistemático',
            description: 'Conteúdos do básico ao avançado, da teoria à prática',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'Divertido e Desafiador',
            description:
              'Estímulo do interesse e potencial, crescimento através da exploração',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'Cursos de Inteligência Artificial',
        items: [
          {
            name: 'Fazenda Inteligente',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'Casa Inteligente',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'Transporte Inteligente',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'Fábrica Inteligente',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'Banner de Cursos de IA',
        text: 'Aprendizado baseado em projetos, integração interdisciplinar, desenvolvimento de habilidades práticas, cooperação e resolução de problemas. Segurança e personalização, exibição de resultados aumenta o senso de realização, apoiando o crescimento dos alunos.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: 'Produtos a Laser',
        title: 'Good Laser Produtos a Laser',
        description:
          'Seguro e fácil de usar, equipamentos e soluções de corte/gravação a laser para ambientes educacionais',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'Nossas Vantagens',
      extraNote: {
        light640_640:
          'Excelentes trabalhos de corte e gravação\nVários modelos, diferentes potências de laser, atendendo a diferentes necessidades de aplicação\nTipo de laser: DC CO2  Potência do laser: 60W-130W',
      },
      center: {
        title: 'Centro de Produtos',
        laser_accessories: 'Acessórios a laser',
        air_purifier_name: 'Purificador de ar',
        description:
          'Fornecemos soluções de combinação de equipamentos a laser de acordo com o nível de ensino das escolas. A Zetok lançou quatro planos oficiais de equipamentos a laser, que as escolas podem escolher conforme suas necessidades de ensino.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Laser de Alta Qualidade e Precisão',
                bgColor: '#4285F4',
                description:
                  'Tubo de laser de CO2 de alta qualidade e espessura, comprimento de onda de 10640nm, fornece laser de CO2 de 55W de alta qualidade, corte máximo de até 20mm (acrílico), velocidade de trabalho de 600mm/s e precisão de posicionamento repetitivo de 0,025mm, permitindo cortes e gravações rápidos e precisos de obras criativas.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Sistema Integrado de Filtragem Tripla de Exaustão',
                bgColor: '#FFBC0C',
                description:
                  'Sistema de filtragem de fumaça com rede, carvão ativado e camada UV de ozônio integrado na caixa. Mais limpo e ecológico, além de compacto e conveniente, sem necessidade de adquirir filtros adicionais.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Segurança Prioritária',
                bgColor: '#34A853',
                description:
                  'Testado no laboratório SGS com os mais altos padrões de segurança, certificado pela FDA como produto a laser Classe I, com indicadores de segurança e estado de operação claros, permitindo monitoramento intuitivo.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Sistema de Corte a Laser Fácil de Usar e Potente',
                bgColor: '#0F9D58',
                description:
                  '· Parâmetros ajustáveis conforme o material: corte, gravação profunda, gravação superficial, varredura, etc.\n· Diversas imagens e modelos para aumentar a eficiência do design.\n· Câmera integrada para captura precisa, auxiliando no design e tornando as ideias realidade.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Área de Trabalho',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610(1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Auto-foco Eficiente + Posicionamento com Ponto Vermelho',
                  bgColor: '#FFBC0C',
                  description:
                    'O auto-foco permite posicionamento rápido e preciso antes do corte ou gravação. O feixe de ponto vermelho mostra a posição de trabalho em tempo real, economizando tempo e melhorando o resultado.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Design de Porta Traseira Aberta',
                  bgColor: '#34A853',
                  description:
                    'O design da porta traseira aberta permite colocar materiais de comprimento ilimitado, tornando o trabalho mais conveniente e com menos restrições.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Excelentes Trabalhos de Corte e Gravação',
                  bgColor: '#4285F4',
                  description:
                    'A máquina possui plataforma ampla, garantindo precisão industrial em madeira e acrílico, permitindo produção em série de peças de alta qualidade.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Laser de Alta Qualidade e Componentes Precisos',
                  bgColor: '#FFBC0C',
                  description:
                    'Linha de produtos diversificada, com diferentes tipos de laser e velocidades de processamento, atendendo às diversas necessidades de materiais como madeira, vidro e acrílico.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Teste Rigoroso de Qualidade e Garantia',
                  bgColor: '#34A853',
                  description:
                    'Testes rigorosos e controle preciso do caminho óptico garantem saída de laser estável e consistente. Permite gravação uniforme mesmo em detalhes complexos.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Funções de Segurança Avançadas',
                  bgColor: '#4285F4',
                  description: `1. Parada de emergência
<br>2. Luz de alerta
<br>3. Interruptor à prova d'água
<br>4. Conexão à terra
<br>5. Detector de calor interno aciona alarme em caso de anomalia
<br>6. Proteção da tampa
<br>7. Janela de vidro temperado durável`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Durabilidade e Qualidade Excelente',
                  bgColor: '#FFBC0C',
                  description: `1. Ideal para projetos únicos ou produção em massa.
<br>2. Área de trabalho ampla, de 600 x 400MM a 1600 x 1000MM.
<br>3. Velocidade de gravação inigualável.
<br>4. Design por especialistas do setor.
<br>5. Excelente para aplicações personalizadas, educacionais e industriais.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Otimização de Produção com Monitoramento Inteligente',
                  bgColor: '#34A853',
                  description:
                    'Protege componentes sensíveis (eixos, cabeça do laser, óptica, lentes) contra poeira e sujeira, garantindo operação sem falhas por muitos anos.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title:
                    'Auto-foco Eficiente + Posicionamento com Ponto Vermelho',
                  bgColor: '#4285F4',
                  description:
                    'Auto-foco para posicionamento rápido e preciso antes do corte ou gravação, com ponto vermelho indicando posição em tempo real, economizando tempo e melhorando resultados.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Excelentes Trabalhos de Corte e Gravação',
                  bgColor: '#FFBC0C',
                  description:
                    'Plataforma ampla, ideal para madeira e acrílico, garantindo precisão e eficiência industrial, apta para produção em série.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'Durabilidade e Qualidade Excelente',
                  bgColor: '#34A853',
                  description: `1. Ideal para projetos únicos ou produção em massa.
<br>2. Área de trabalho ampla, de 600 x 400MM a 1600 x 1000MM.
<br>3. Velocidade de gravação inigualável.
<br>4. Design por especialistas do setor.
<br>5. Excelente para aplicações personalizadas, educacionais e industriais.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Gravador Azul Portátil',
                bgColor: '#4285F4',
                description:
                  'Design moderno, compacto e elegante, ideal para residências, escolas ou estúdios. Corpo metálico com tampa acrílica, combinando portabilidade com desempenho de corte de 20W.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Processamento Fechado para Segurança',
                bgColor: '#FFBC0C',
                description:
                  'O gravador azul é totalmente fechado; ao abrir a tampa durante o trabalho, ele pausa automaticamente. Interruptor de emergência para desligamento imediato.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Suporta Vários Materiais',
                bgColor: '#34A853',
                description:
                  'Permite gravação em centenas de materiais, incluindo objetos cilíndricos, copos e formas redondas, ideal para pequenos negócios.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Aplicações Diversificadas',
                bgColor: '#4285F4',
                description:
                  'Adequado para várias indústrias, incluindo gravação de joias, itens personalizados, identificação de peças, cobrindo desde joias e frascos de perfume até pequenas placas industriais.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Inovação na Educação',
                bgColor: '#FFBC0C',
                description:
                  'Mark M20 traz precisão industrial para a educação, capacitando alunos a desenvolver habilidades desde marcação básica até projetos complexos.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Compacto e Moderno',
                bgColor: '#34A853',
                description:
                  'Design compacto, baixo ruído, janela ampla, durável e seguro, adequado para instituições educacionais e ambientes públicos.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'Marcações em Segundos',
                bgColor: '#0F9D58',
                description:
                  'Mesmo com letras pequenas, a marcação é realizada em segundos, combinada com o software LightMaker, garantindo produtividade elevada.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'Acessórios',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
· Aplicação: Locais que geram fumaça, poeira, gases tóxicos ou poluentes.
<br>· Áreas de uso: Eletrônica, brinquedos, metais de precisão, medicina, etc.
<br>· Design: Estação simples ou dupla ajustável.
<br>· Filtros: Múltiplas camadas.
<br>· Fluxo de ar: Ajustável conforme a quantidade de exaustão.
<br>· Eficiência de purificação: Até 99,97%.
<br>· Saída de ar: Ar limpo liberado diretamente no ambiente.`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· Tipo: Equipamento auxiliar para corte/gravação a laser.
<br>· Função: Permite rotação da peça.
<br>· Objetos compatíveis: Cilíndricos, tubulares, etc.
<br>· Expansão: Permite processar objetos 3D, não apenas placas planas.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `
· Máquina de moldagem eficiente e precisa.
<br>· Controle CNC fácil de usar.
<br>· Vários moldes disponíveis.
<br>· Sistema de fixação rápido.
<br>· Segurança completa.
<br>· Compatível com vários materiais.`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
  },
  support: {
    afterSales: {
      banner: {
        alt: 'Banner de downloads de tutoriais',
        title: 'Download de Tutoriais',
        image: require('@/assets/after/banner.png'),
      },
      downloadText: 'Baixar Tutoriais',
      items: [
        {
          id: 'mk-1',
          name: 'Fazenda Inteligente',
          image: 'https://picsum.photos/seed/as-farm1/588/391',
          link: '#',
        },
        {
          id: 'mk-2',
          name: 'Casa Inteligente',
          image: 'https://picsum.photos/seed/as-home1/588/391',
          link: '#',
        },
        {
          id: 'mk-3',
          name: 'Trânsito Inteligente',
          image: 'https://picsum.photos/seed/as-traffic1/588/391',
          link: '#',
        },
        {
          id: 'mk-4',
          name: 'Fábrica Inteligente',
          image: 'https://picsum.photos/seed/as-factory1/588/391',
          link: '#',
        },
        {
          id: 'mk-5',
          name: 'Espaço Maker',
          image: 'https://picsum.photos/seed/as-makerspace1/588/391',
          link: '#',
        },
        {
          id: 'mk-6',
          name: 'Curso de Robótica',
          image: 'https://picsum.photos/seed/as-robot1/588/391',
          link: '#',
        },
        {
          id: 'mk-7',
          name: 'Tutoriais de IA',
          image: 'https://picsum.photos/seed/as-ai1/588/391',
          link: '#',
        },
        {
          id: 'mk-8',
          name: 'Tutoriais de IoT',
          image: 'https://picsum.photos/seed/as-iot1/588/391',
          link: '#',
        },
      ],
    },
  },
};
